import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/navigation/Header.js";
import React, { Component } from 'react';
import { AppBar, Toolbar, Grid, Menu, MenuItem, Button, Select, TextField, Typography, Tooltip, Fade, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from "react-cookie";
import Util, { getSelectedPartner } from "../../util/Util";
import { Dialog, SimpleSnackbar, PartnerSelector } from "../common";
import { TokenDialog } from "./index";
import { withRouter } from 'react-router-dom';
import { BASE_URIS, COOKIE_NAMES, ID_SPACE, LOCAL_STORAGE_ITEM_NAMES, Q_STRING, SESSION_STORAGE_ITEM_NAMES, TPIS_CAPABILITIES as CAPS } from "../domain/constants";
import { ADMIN, HOMEPAGE, LOGIN, SEARCH, UPLOAD, RESETCODE, SUPPORT, SEARCH_RESULT } from "../Routes";
import AccountCircle from '@material-ui/icons/AccountCircle';
import Search from '@material-ui/icons/Search';
import LoggedInUser from "../login/LoggedInUser";
import { clearUserDataFromLocalStorage, clearImpersonationUserData } from "../../util/StorageUtil";
import { stringToList } from "../../util/StringUtil";
const styles = theme => ({
  title: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'inline-block',
    padding: 15,
    marginRight: 5
  },
  appBar: {
    //width: `calc(100% - ${SIDE_NAV_WIDTH}px)`,
    //marginLeft: SIDE_NAV_WIDTH,
    color: 'secondary'
  },
  root: {
    flexGrow: 1
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  sronly: {
    position: 'absolute',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
  },
  inputStyle: {
    margin: '5px',
    padding: '5px'
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    margin: '5px'
  },
  txtFld: {
    margin: theme.spacing(1),
    flexBasis: 200
  }
});
class Header extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleClick", event => {
      this.setState({
        anchorEl: event.currentTarget
      });
    });
    _defineProperty(this, "handleClose", () => {
      this.setState({
        anchorEl: null
      });
    });
    _defineProperty(this, "viewSatTokenDialog", () => {
      this.state.anchorEl = null;
      this.forceUpdate();
      const token = sessionStorage.getItem(SESSION_STORAGE_ITEM_NAMES.TPIS_TOKEN);
      if (token != null) {
        this.openSatTokenDialog(token);
      } else {
        Util.fetchWithRedirect(BASE_URIS.token, 'GET', this.props).then(resp => {
          sessionStorage.setItem(SESSION_STORAGE_ITEM_NAMES.TPIS_TOKEN, resp.token);
          this.openSatTokenDialog(resp.token);
        }).catch(e => {
          Util.log('Header.viewSatTokenDialog', true, e, false);
          Util.createDialog('Token not found', 'Unable to display token', this.dialogRef);
        });
      }
    });
    _defineProperty(this, "logout", () => {
      const cookies = this.props.cookies;
      fetch(BASE_URIS.logout, {
        method: 'POST',
        headers: {
          'credentials': 'include'
        }
      }).then(v => {
        if (v != null && v.status !== 200) {
          Util.createDialog("Logout Unsuccessful", "The server could not handle the logout request", this.dialogRef);
        } else {
          clearUserDataFromLocalStorage();
          cookies.remove(COOKIE_NAMES.CSRF_TOKEN);
          this.props.history.push(LOGIN);
        }
      }).catch(e => console.warn(e));
      this.setState({
        anchorEl: null
      });
    });
    _defineProperty(this, "handleChange", name => event => {
      this.setState({
        [name]: event.target.value
      });
    });
    _defineProperty(this, "handleKeyPress", e => {
      if (e.key === 'Enter') {
        this.routeSearch();
      }
    });
    this.state = {
      anchorEl: null,
      user: localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.username),
      nameSpace: ID_SPACE.ADI,
      searchInput: '',
      isLoginPage: this.determineIsLoginPage()
    };
    this.appRef = props.appRef;
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
    this.tokenDialog = null;
    this.setTokenDialogRef = element => {
      this.tokenDialog = element;
    };
    this.snackbarRef = null;
    this.setSnackbarRef = element => {
      this.snackbarRef = element;
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props != null && this.props.location != null) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        this.setState({
          isLoginPage: this.determineIsLoginPage()
        });
      }
    }
  }
  determineIsLoginPage() {
    if (this.props != null && this.props.location != null) {
      if (this.props.location.pathname === LOGIN) {
        return true;
      }
    }
    return false;
  }
  navigateTo(target) {
    this.props.history.push(target);
    this.setState({
      anchorEl: null
    });
  }
  help() {
    this.setState({
      anchorEl: null
    });
    window.open(BASE_URIS.docs);
  }
  openSatTokenDialog(token) {
    this.tokenDialog.setToken(token);
    this.tokenDialog.setParentSnackbarRef(this.snackbarRef);
    this.tokenDialog.handleClickOpen();
  }
  routeSearch() {
    if (this.state.searchInput === null || this.state.searchInput === '' || this.state.searchInput === undefined) {
      Util.createDialog("Missing 'ID' value", 'You must input an ID in order to use the search feature', this.dialogRef);
      return;
    }
    let path = SEARCH;
    let search;
    if (this.state.nameSpace === Q_STRING.TITLE) {
      path = SEARCH_RESULT;
      search = "?".concat(Q_STRING.TITLE, "=").concat(encodeURIComponent(this.state.searchInput));
    } else {
      search = "?".concat(Q_STRING.ENTITY_ID, "=").concat(this.state.searchInput);
    }
    this.setState({
      searchInput: ''
    });
    this.props.history.push({
      pathname: path,
      search: search,
      state: {
        entityProvider: this.state.nameSpace,
        searchInput: this.state.searchInput
      }
    });
    this.forceUpdate();
  }
  render() {
    const _this$state = this.state,
      anchorEl = _this$state.anchorEl,
      isLoginPage = _this$state.isLoginPage;
    const classes = this.props.classes;
    const username = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.username);
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    const impersonating = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.impersonatingUser) === "true";
    const title = Header.getLoggedInUserToolTipTitle();
    return /*#__PURE__*/React.createElement(AppBar, {
      position: "static",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 239,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Toolbar, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 241,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(TokenDialog, {
      ref: this.setTokenDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 242,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 243,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 246,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 1,
      md: 1,
      lg: 1,
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.navigateTo(HOMEPAGE),
      style: {
        color: 'white'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 251,
        columnNumber: 29
      }
    }, "TPIC")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      sm: 4,
      md: 4,
      lg: 4,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 254,
        columnNumber: 25
      }
    }, isLoginPage === false && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 257,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 259,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 261,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Select, {
      disableUnderline: true,
      value: this.state.nameSpace,
      onChange: this.handleChange('nameSpace'),
      displayEmpty: true,
      variant: "outlined",
      label: "ID Namespace",
      style: {
        minWidth: '90%'
      },
      onKeyPress: this.handleKeyPress,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 262,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: ID_SPACE.ADI,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 267,
        columnNumber: 45
      }
    }, "ADI ID"), /*#__PURE__*/React.createElement(MenuItem, {
      value: "Mike",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 269,
        columnNumber: 45
      }
    }, "MediaGUID"), /*#__PURE__*/React.createElement(MenuItem, {
      value: ID_SPACE.MERLIN,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 270,
        columnNumber: 45
      }
    }, "Merlin ID"), /*#__PURE__*/React.createElement(MenuItem, {
      value: Q_STRING.TITLE,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 271,
        columnNumber: 45
      }
    }, "Title"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 274,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "search-input",
      type: "text",
      label: "Search",
      className: classes.txtFld,
      variant: "filled",
      value: this.state.searchInput,
      onChange: this.handleChange('searchInput'),
      onKeyPress: this.handleKeyPress,
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 282,
            columnNumber: 53
          }
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: () => this.routeSearch(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 283,
            columnNumber: 57
          }
        }, /*#__PURE__*/React.createElement(Search, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 283,
            columnNumber: 100
          }
        })))
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 275,
        columnNumber: 41
      }
    }))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 4,
      md: 4,
      lg: 4,
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 294,
        columnNumber: 25
      }
    }, isLoginPage === false && /*#__PURE__*/React.createElement(PartnerSelector, {
      parentRef: this.appRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 297,
        columnNumber: 29
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      sm: 3,
      md: 3,
      lg: 3,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 301,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 303,
        columnNumber: 29
      }
    }, impersonating === true && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 307,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      style: {
        color: 'red'
      },
      onClick: () => this.stopImpersonating(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 309,
        columnNumber: 37
      }
    }, "Stop Impersonating")), isLoginPage === false && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 314,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 317,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: title,
      TransitionComponent: Fade,
      classes: {
        tooltip: classes.lightTooltip
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 318,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(AccountCircle, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 320,
        columnNumber: 45
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 323,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: title,
      TransitionComponent: Fade,
      classes: {
        tooltip: classes.lightTooltip
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 324,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        textOverflow: "ellipses",
        overflow: "hidden"
      },
      noWrap: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 326,
        columnNumber: 45
      }
    }, username)))), isLoginPage === false && caps != null && caps.includes(CAPS.ADMIN) && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 335,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        color: 'white'
      },
      onClick: () => this.navigateTo(ADMIN),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 337,
        columnNumber: 37
      }
    }, "Admin Portal")), isLoginPage === false && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      wrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 343,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        color: 'white'
      },
      "aria-owns": anchorEl ? 'simple-menu' : undefined,
      "aria-haspopup": "true",
      onClick: this.handleClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 345,
        columnNumber: 37
      }
    }, "Menu"), /*#__PURE__*/React.createElement(Menu, {
      id: "simple-menu",
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      onClose: this.handleClose,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 352,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => this.navigateTo(HOMEPAGE),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 357,
        columnNumber: 41
      }
    }, "Home"), Util.isVisibleForCapabilities(caps, [CAPS.WRITE]) && /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => this.navigateTo(UPLOAD),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 359,
        columnNumber: 41
      }
    }, "Upload"), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: this.viewSatTokenDialog,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 361,
        columnNumber: 41
      }
    }, "View Token"), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => this.navigateTo(RESETCODE),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 362,
        columnNumber: 41
      }
    }, "Change Password"), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => this.navigateTo(SUPPORT),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 363,
        columnNumber: 41
      }
    }, "Contact Support"), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: () => this.help(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 364,
        columnNumber: 41
      }
    }, "Help"), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: this.logout,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 365,
        columnNumber: 41
      }
    }, "Log Out"))))))));
  }
  static getLoggedInUserToolTipTitle() {
    const loggedInUser = [React.createElement('li', null, /*#__PURE__*/React.createElement(LoggedInUser, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 378,
        columnNumber: 63
      }
    }))];
    return React.createElement('ul', {
      style: {
        listStyleType: 'none',
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0
      }
    }, loggedInUser);
  }
  stopImpersonating() {
    const iUser = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedUsername);
    const user = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.username);
    fetch(BASE_URIS.stop_impersonating, {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json',
        'x-meta-tpic-partner': getSelectedPartner()
      }
    }).then(resp => {
      if (resp.ok === true) {
        clearImpersonationUserData();
        console.log(user + " was an imposter. 0 imposters remain");
        window.location.href = "/";
      } else {
        Util.createDialog("Could Not Stop Impersonating", "unable to stop impersonating '" + iUser + "'. See response in console", this.dialogRef);
        console.dir(resp);
      }
    }).catch(err => {
      console.dir(err);
      Util.createDialog("Could Not Stop Impersonating", "unable to stop impersonating '" + iUser + "'. See error in console", this.dialogRef);
    });
  }
}
export default withStyles(styles)(withRouter(withCookies(Header)));